import { useMedia } from "react-use";

const BREAKPOINTS = {
  tablet: 768,
  laptop: 1024,
  desktop: 1280,
} as const;

export const useResponsive = () => {
  const isMobile = useMedia(`(max-width: ${BREAKPOINTS.laptop - 1}px)`, true);
  const isTablet = useMedia(`(max-width: ${BREAKPOINTS.tablet - 1}px)`, true);
  const isDesktop = useMedia(`(min-width: ${BREAKPOINTS.desktop}px)`, true);

  return {
    isMobile,
    isTablet,
    isDesktop,
  };
};

export const useIsMobileView = () => {
  // 서버측 예외처리를 위해 강제로 기본값을 true 로 함
  return useMedia(`(max-width: ${BREAKPOINTS.laptop - 1}px)`, true);
};
